/**
 * API Endpoint definitions and Base URL configuration.
 */

export const APIEndpoints = {
  LoginUsingEmail: "/crm/login",
  GetProfile: "/crm/profile",
  GetStudents: "/crm/coql",
  CreateAttendance: "/crm/attendance/create",
  SearchAttendance: "/crm/coql",
  CreateClassContent: "/crm/create",
  EditClassContent: "/crm/edit",
  SearchClassContent: "/crm/coql",
  GetClassContentById: "/crm/get",
  GetPreviewLink: "/workdrive/preview-link",
  GetDownloadLink: "/workdrive/download-link",
} as const;

export const BASE_URL: string = "https://aksharart-api.bapsanz.org.au";
